<div class="secondary-sidepanel__content pl-25 pr-25">
  <div>
    <a class="close" (click)="onClose($event)"><i class="fa-regular fa-times"></i></a>
  </div>
  <ng-container>
    <h4 class="card-panel-title --minimal">Information Panel</h4>
    <div class="box--soft customer-details-box card-panel profile-form profile-form--revised --minimal mt-20"
      style="width: 100%;">
      <div class="profile-form__fields">
        <div class="flex-row">
          <div class="flex-col-xs-12">
            <h5 class="box-title">Agent Information</h5>
          </div>
          <div class="flex-col-xs-6">
            <div class=" cd-label "><i class="fa-light fa-user-headset"></i>Agent</div>
            <div class=" cd-value mt-10">{{this.agentInformation.agent}}</div>
          </div>
          <div class="flex-col-xs-6">
            <div class=" cd-label "><i class="fa-light fa-user-tie"></i>Supervisor</div>
            <div class=" cd-value mt-10">{{this.agentInformation.supervisor}}</div>
          </div>
          <div class="flex-col-xs-6">
            <div class=" cd-label "><i class="fa-light fa-location-dot"></i>Location</div>
            <div class=" cd-value mt-10">{{this.agentInformation.location}}</div>
          </div>
          <div class="flex-col-xs-6">
            <div class=" cd-label "><i class="fa-light fa-user"></i>
              Client</div>
            <div class=" cd-value mt-10"> {{this.agentInformation.client}}
            </div>
          </div>
          <div *ngIf="!isViewMode" class="flex-col-xs-6">
            <div class=" cd-label "><i class="fa-light fa-bullseye-arrow"></i>
              Campaign</div>
            <div class=" cd-value mt-10">{{this.agentInformation.campaign}}
            </div>
          </div>
        </div>
      </div>
      <div class="profile-form__fields">
        <div class="flex-row">
          <div class="flex-col-xs-12">
            <h5 class="box-title">Call Information</h5>
          </div>
          <div class="flex-col-xs-12">
            <div class=" cd-label "><i class="fa-light fa-phone"></i>Call SID</div>
            <!-- <div class=" cd-value mt-10">CA937974e2727277c823842f50e7b6eb65</div> -->
            <input type="text" id="title-input" name="title" [placeholder]="callInformation.callID" disabled="">
          </div>

          <div class="flex-col-sm-6">
            <div class="cd-label "><i class="fa-light fa-globe"></i>TFN</div>
            <!-- <label for="title-input">BTN/MSISDN</label> -->
            <input type="text" id="title-input" name="title" [placeholder]="callInformation.tfn" disabled="">
          </div>
          <div class="flex-col-sm-6">
            <div class=" cd-label "><i class="fa-light fa-calendar"></i>Call Date</div>
            <!-- <label for="title-input">Call Date</label> -->
            <input type="text" id="title-input" name="title" [placeholder]="callInformation.callDate" disabled="">
          </div>
          <div class="flex-col-sm-6">
            <div class=" cd-label "><i class="fa-light fa-calendar"></i>Wrap Time</div>
            <!-- <label for="title-input">Call Date</label> -->
            <input type="text" id="title-input" name="title" [placeholder]="callInformation.wrapTime" disabled="">
          </div>
          <div class="flex-col-sm-6">
            <div class=" cd-label "><i class="fa-light fa-calendar"></i>Hold Time</div>
            <!-- <label for="title-input">Call Date</label> -->
            <input type="text" id="title-input" name="title" [placeholder]="callInformation.holdTime" disabled="">
          </div>
          <!-- <div class="flex-col-sm-6">
            <div class=" cd-label "><i class="fa-light fa-clock"></i>Call Time</div>
            <label for="title-input">Call Time</label> 
            <input type="text" id="title-input" name="title" [placeholder]="callInformation.callTime" disabled="">
          </div> -->
          <div class="flex-col-sm-6">
            <div class=" cd-label "><i class="fa-light fa-timer"></i>Call Duration</div>
            <!-- <label for="title-input">Call Duration (mins)</label> -->
            <input type="text" id="title-input" name="title" [placeholder]="callInformation.callDuration" disabled="">
          </div>
          <div class="flex-col-sm-6">
            <div class=" cd-label "><i class="fa-light fa-timer"></i>Call Type</div>
            <!-- <label for="title-input">Call Duration (mins)</label> -->
            <input type="text" id="title-input" name="title" [placeholder]="callInformation.callType" disabled="">
          </div>
          <div class="flex-col-sm-12">
            <div class=" cd-label "><i class="fa-light fa-timer"></i>Disposition</div>
            <!-- <label for="title-input">Call Duration (mins)</label> -->
            <input type="text" id="title-input" name="title" [placeholder]="callInformation.disposition" disabled="">
          </div>
        </div>
      </div>
    </div>

  </ng-container>

 

  <h4 class="card-panel-title --minimal">Evaluation Form</h4>
  <div *ngFor="let record of sections; let i = index"
    [ngClass]="i === 0 ? 'box--soft customer-details-box' : 'box--soft customer-details-box mt-20'">
    <div class="flex-row --minimal">
      <div class="flex-col-sm-6">
        <h5 class="box-title">{{ record?.SectionName }}</h5>
      </div>
      <div class="flex-col-sm-6 ta-r fz-12 tt-uc">
        Section Weightage: {{ calculateSectionWeightage(record).toFixed(2) }}
      </div>
    </div>
    <div class="flex-row">
      <div class="flex-col-sm-4 fz-12">Possible Subtotal: {{ calculatePossibleSubtotal(record).toFixed(2) }}
      </div>
      <div class="flex-col-sm-4 ta-c fz-12"> 
      </div>
      <div class="flex-col-sm-4 ta-r fz-12">Subtotal: {{ calculateSubtotal(record).toFixed(2) }} </div>
    </div>
    <div class="flex-row">
      <div class="flex-col-sm-12">
        <div class="chat__conversation-board --minimal">
          <div *ngFor="let question of record?.Questions" class="chat__conversation-board__message-container">
            <div class="chat__conversation-board__message__context">
              <div class="chat__conversation-board__message__bubble">
                <div *ngIf="record?.SectionType === 0" class="chat__conversation-board__message__person__initial">
                  Q
                </div>
                <div *ngIf="record?.SectionType !== 0"
                  class="chat__conversation-board__message__person__initial --minimal">
                  F
                </div>
                <p>{{ question.Question }}</p>
              </div>
            </div>
            <div class="chat__conversation-board__message__time">
              <div class="dropdown-list-wrapper">
                <div class="dropdown-list">
                  <ng-container *ngIf="question?.Type==0">
                    <label></label>
                    <span class="dropdown-list__opt-select">
                      <select [disabled]="isViewMode" [(ngModel)]="question.selectedOption"
                        (change)="updateScores(record)" name="disposition">
                        <option *ngIf="isViewMode" [value]="question.selectedOption" selected>
                          {{question.selectedOption.Option}}
                        </option>
                        <ng-container *ngIf="!isViewMode">
                          <option *ngFor="let option of question.Options" [ngValue]="option">{{ option.Option }}
                          </option>
                        </ng-container>
                      </select>
                    </span>
                  </ng-container>
                  <div *ngIf="question?.Type==2" class="profile-form">
                    <div class="profile-form__fields">
                      <input appFirstInput (input)="updateScores(record)" id="title-input" name="title"
                        [disabled]="isViewMode" [(ngModel)]="question.selectedOption" type="textarea"
                        [value]="question.selectedOption">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <h4 class="card-panel-title --minimal">Attachments Panel</h4>
  <div
    class="box--soft customer-details-box card-panel profile-form profile-form--revised --minimal" style="width: 100%;">
    <div class="profile-form__fields">
      <div class="flex-row">
        <div class="flex-col-xs-12">
          <h5 class="box-title">Attachments</h5>
        </div>
        <div class="flex-col-xs-6">
          <div class="cd-label ">
            <input accept=".jpeg, .png, .word, .excel, .pdf" id="fileInput" type="file"
              (change)="onFileSelected($event)" hidden />
            <div class="btns-group">
              <label *ngIf="!isViewMode" for="fileInput" class="btns-group__btn btns-group__btn--with-bg">Choose File</label>
              <div style="display: flex;" *ngIf="fileName" class=" cd-value mt-10">{{ fileName }}
                <ng-container *ngIf="isViewMode && !disableActions; else uploadFile">
                     <i *ngIf="isDownloading && allowDownload" class="fa-dark fa-solid fa-spin fa-spinner fa-fw ml-10"></i>
                    <a *ngIf="!isDownloading && allowDownload" data-tooltip="Download" data-tooltip-conf="top" class="cursor-pointer ml-10" (click)="onDownload()">
                      <i class="fa-light fa-download"></i>
                    </a>
                 </ng-container>
                <ng-template #uploadFile>
                  <ng-container *ngIf="!isViewMode && !isFileUploaded">
                    <i *ngIf="isUploading" class="fa-dark fa-solid fa-spin fa-spinner fa-fw ml-10"></i>
                    <a *ngIf="!isUploading" data-tooltip="Upload" data-tooltip-conf="top" class="cursor-pointer ml-10" (click)="onUpload()">
                      <i class="fa-light fa-upload"></i>
                    </a>
                  </ng-container>
                </ng-template>
              </div>
              <div style="display: flex;" *ngIf="!fileName" class=" cd-value mt-10"> No Record Found
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="box--soft customer-details-box profile-form profile-form--revised mt-20 --minimal">
    <div class="profile-form__fields">
      <div class="flex-row">
        <div class="flex-col-xs-12">
          <h5 class="box-title">
            Scoring Details
          </h5>
        </div>
        <div [(ngModel)]="totalPossiblePoints" class="flex-col-sm-6">
          <label for="title-input">Total Points Possible</label>
          <input type="text" id="title-input" name="title" [placeholder]="totalPossiblePoints" disabled="">
        </div>
        <div [(ngModel)]="totalScoredPoints" class="flex-col-sm-6">
          <label for="title-input">Total Points Scored</label>
          <input type="text" id="title-input" name="title" [placeholder]="totalScoredPoints" disabled="">
        </div>
        <div [(ngModel)]="bonusPoints" class="flex-col-sm-6">
          <label for="title-input">Bonus Points</label>
          <input [(ngModel)]="bonusPoints" [disabled]="isViewMode" id="title-input" [value]="bonusPoints" name="title"
            [placeholder]="bonusPoints">
        </div>
        <div [(ngModel)]="totalOverallScoredPoints" class="flex-col-sm-6">
          <label for="title-input"> Total OverAll Score</label>
          <input type="text" id="title-input" name="title" [placeholder]="totalOverallScoredPoints" disabled="">
        </div>
        <div [(ngModel)]="overaAllPerc" class="flex-col-sm-6">
          <label for="title-input">Percentage</label>
          <input type="text" id="title-input" name="title" [placeholder]="overaAllPerc" disabled="">
        </div>
        <div [(ngModel)]="evaluatorComment" class="flex-col-sm-12">
          <label for="title-input">Comments</label>
          <div class="note-action-wrapper">
            <div class="note-action note-action--secondary">
              <div class="note-action__boxes">
                <textarea [(ngModel)]="evaluatorComment" [disabled]="isViewMode && !isDisputed" rows="10" cols="1"
                  id="text-calculate" [placeholder]="evaluatorComment" (input)="onCommentInput($event,1)"
                  maxlength="{{ maxCharacters }}">
                </textarea>
                <div>
                  <span id="textsss">{{ QAcharactersLeft }} characters left
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- call back required comment -->
        <div class="checkbox">
          <div class="checkbox__content">
            <input type="checkbox" [disabled]="isViewMode" name="checkbox-1" id="checkbox-1"
              [(ngModel)]="isCallbackRequired">
            <label for="checkbox-1">Callback Required</label>
          </div>
        </div>
        <div *ngIf="isCallbackRequired" [(ngModel)]="callBackComment" class="flex-col-sm-12">
          <label for="title-input">Callback Comments</label>
          <div class="note-action-wrapper">
            <div class="note-action note-action--secondary">
              <div class="note-action__boxes">
                <textarea [(ngModel)]="callBackComment" [disabled]="isViewMode" rows="10" cols="1" id="text-calculate"
                  [placeholder]="callBackComment" (input)="onCommentInput($event,3)" maxlength="{{ maxCharacters }}">
                  </textarea>
                <div>
                  <span id="textsss">{{ CallbackRequiredcharactersLeft }} characters left</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="isViewMode" [(ngModel)]="disputeComments" class="flex-col-sm-12">
          <label for="title-input">Dispute Comments</label>
          <div class="note-action-wrapper">
            <div class="note-action note-action--secondary">
              <div class="note-action__boxes">
                <textarea [(ngModel)]="disputeComments" [disabled]="isDisputed" rows="10" cols="1" id="text-calculate"
                  [placeholder]="disputeComments" (input)="onCommentInput($event,2)" maxlength="{{ maxCharacters }}">
                  </textarea>
                <div>
                  <span id="textsss">{{ SUPcharactersLeft }} characters left
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="btns-group-wrapper --minimal">
    <div class="btns-group">
      <a *ngIf="!isViewMode" class="btns-group__btn btns-group__btn--with-bg" (click)="Calculate()">Calculate Score</a>
      <ng-container *ngIf="disableActions">
        <a *ngIf="!isViewMode" class="btns-group__btn btns-group__btn--with-bg" (click)="submitForm(false)">Save
          Evaluation</a>
        <a *ngIf="isDisputed || !isViewMode" class="btns-group__btn btns-group__btn--with-bg"
          (click)="isDisputed ? ApproveOrDisputeForm(0) : submitForm(true)">Send for Approval</a>
      </ng-container>
      <ng-container *ngIf="status!=='Approved' && status!='Coached' && !isDisputed && isViewMode && !disableActions">
        <a class="btns-group__btn btns-group__btn--with-bg" (click)="ApproveOrDisputeForm(4)">Save</a>
        <a class="btns-group__btn btns-group__btn--with-bg"
          (click)="ApproveOrDisputeForm(2)">Approve</a>
        <a class="btns-group__btn btns-group__btn--with-bg" (click)="ApproveOrDisputeForm(3)">Dispute</a>
        <a *ngIf="showCoach" class="btns-group__btn btns-group__btn--with-bg"
          (click)="ApproveOrDisputeForm(1)">Coach</a>
      </ng-container>
    </div>
  </div>
</div>